import React, { useState } from "react";
import NavBar from "../../components/NavBar";
import { useHistory } from "react-router-dom";
import { DateRevivier, Session } from '../../Types';
import { GlobalState } from '../../AppContext';
import './summary.scss';
import moment from 'moment';
import axios, { AxiosRequestConfig } from 'axios';
import {MailIcon} from '../../components/Icons';
import { PAYLOAD_URL, API_KEY} from '../../constants';
import { isRegExp } from "util";


const SessionSummary: React.SFC<{}> = () => {
  let history = useHistory();
  // work out which summary to view
  let toView = Number.parseInt(window.location.hash.substr(1));
  let session: Session = {...GlobalState.state};
  let storedSessions: Session[] = [];
  let sessionsJSON = localStorage.getItem("sessions");
  
  const [recipientEmail, setRecipientEmail] = useState('');
  const [uploading, setUploading] = useState(false);
  const [uplaodError, setUploadError] = useState(false);
  
  if (sessionsJSON) {
    let tempSessions = JSON.parse(sessionsJSON, DateRevivier ) as Session[];
    if (!Array.isArray(tempSessions)){
      storedSessions.push(tempSessions);
    } else {
      storedSessions = tempSessions;
    }
    storedSessions.forEach( (stored) =>{
      if(stored.session_id === toView) {
        session = {...stored};
      }
    });
  }

  const [notUploaded, setNotUploaded] = useState((session.uploaded == null) ? true : false);
  const [uploaded, setUploaded] = useState((session.uploaded == null) ? false : true);
  const herd = session.herd;
  const count = session.animals.length;
  let cowNormalCount = 0;
  let cowMildCount = 0;
  let cowSevereCount = 0;
  let cowInjuredCount = 0;

  let totalMildCount = 0;
  let totalSevereCount = 0;

  session.animals.forEach(animal => {
    if(animal.tailCondition === "normal") { cowNormalCount++; return; }
    if( animal.highMildCount > 0 || animal.midMildCount > 0 || animal.lowMildCount > 0) { 
      cowMildCount++;
    }
    if( animal.highSevereCount > 0 || animal.midSevereCount > 0 || animal.lowSevereCount > 0) { 
      cowSevereCount++;
    }
    if(animal.activeInjury) { cowInjuredCount ++; };
    totalSevereCount = animal.highSevereCount + animal.midSevereCount + animal.lowSevereCount;
    totalMildCount = animal.highMildCount + animal.midMildCount + animal.lowMildCount;
  });

  const homeHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.push('/');
  }
  const backHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.goBack();
  }

  const uploadHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    let date = moment(session.date).format("DD/MM/YYYY");
    let herd = session.herd;
    let results:String[][] = [];

    results.push(['date','herd','tag_number','tail_condition','active_injury','docked','high_mild_count','high_severe_count','middle_mild_count','middle_severe_count','low_mild_count','low_severe_count']);
    
    session.animals.forEach( (row) => {
      results.push([date,
        herd,
        row.tagNumber.toString(),
        row.tailCondition,
        row.activeInjury.toString(),
        row.dockedPosition,
        row.highMildCount.toString(),
        row.highSevereCount.toString(),
        row.midMildCount.toString(),
        row.midSevereCount.toString(),
        row.lowMildCount.toString(),
        row.lowSevereCount.toString() 
      ]);
    });

    let payload = {
      herd: herd,
      date: date,
      recipient: recipientEmail,
      results: results
    }
    
    const config: AxiosRequestConfig = {
      headers: { 'X-Api-Key': API_KEY },
    }
    setUploading(true);
    setNotUploaded(false);
    axios.post(PAYLOAD_URL, payload, config)
    .then(res => {
      if ( res.data === "Success"){
        for (let stored of storedSessions) {
          if(stored.session_id === session.session_id) { 
              stored.uploaded = new Date();
              stored.closed = new Date();
              localStorage.setItem('sessions', JSON.stringify(storedSessions));
              break;
          }
        }
        setUploaded(true);
        localStorage.setItem('sessions', JSON.stringify(storedSessions));
      } else {
        setUploadError(true);
      }
      setUploading(false);
    });
  }


  
  const viewAnimalsHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.push('/view_animals#' + toView);
  }

  const viewActiveInjuriesHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.push('/active_injuries#' + toView);
  }

  const emailHandler = (event: React.FormEvent<HTMLInputElement>) => {
      setRecipientEmail(event.currentTarget.value);
  }

  const resendHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setUploading(false);
    setNotUploaded(true);
    setUploaded(false);
  }


  return (
    <>
      <NavBar 
        backBtnTitle="Back"
        backBtnClick={backHandler}
        actionBtnTitle="Home"
        actionBtnClick={homeHandler}
        supTitle="Herd:"
        title={herd}
      />
      <div className="content-pane">

        {notUploaded &&
          <div className="alert-panel session-alert mbm" >
            <h5>This session has not been uploaded.</h5>
            <label className="rpg_form-control clear">
              <span>Enter an email to send results to:</span>
                <input type="email" placeholder="e.g. email@website.co.nz" onChange={emailHandler}  />
              </label>
            <button className="rpg_button action small" onClick={uploadHandler}><MailIcon fill="#ffffff" /> Upload</button>
          </div>
        }

        {uploaded &&
          <div className="resend-panel">
            <h5>This session has been uploaded.</h5>
            <button className="rpg_button upload_btn" onClick={resendHandler}>UPLOAD AGAIN</button>
          </div>
        }

        {uploading &&
          <div className="alert-panel session-alert mbm" >
              <h5>UPLOADING...</h5>
          </div>
        }

        {uplaodError   &&
          <div className="alert-panel session-alert mbm" >
              <h5>THERE WAS AN ERROR UPLOADING<br/>PLEASE TRY AGAIN LATER</h5>
          </div>
        }

        <table className="summary-table">
          <thead>
            <tr>
              <th colSpan={2}>
                Results
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Herd Name:</td>
              <td>{herd}</td>
            </tr>
            <tr>
              <td>Date:</td>
            <td>{moment(session.date).format("DD/MM/YYYY")}</td>
            </tr>
            <tr>
            <td>Total Animals:</td>
              <td>{count}</td>
            </tr>
            <tr>
              <td>Normal Cows:</td>
            <td>{cowNormalCount}</td>
            </tr>
            <tr>
              <td>Cows with mild injuries</td>
              <td>{cowMildCount}</td>
            </tr>
            <tr>
              <td>Cows with severe injuries</td>
              <td>{cowSevereCount}</td>
            </tr>
            <tr>
              <td>Cows with active Injuries</td>
              <td>{cowInjuredCount}</td>
            </tr>
            <tr>
              <td>Total severe injuries</td>
              <td>{totalSevereCount}</td>
            </tr>
            <tr>
              <td>Total mild injuries</td>
              <td>{totalMildCount}</td>
            </tr>
          </tbody>
        </table>
        <button className="rpg_button small" onClick={viewAnimalsHandler}>View Animals</button>
        <button className="rpg_button small" onClick={viewActiveInjuriesHandler}>View Active Injuries</button>
      </div>
    </>
    )
}


export default SessionSummary;